export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0, viewport-fit=cover"},{"name":"keywords","content":"rental dress, rent wedding dresses, designer dress, dresses, gowns, cocktail dress, black tie dress, bnto, AI-powered, clothing subscription, fashion rental subscription"}],"link":[{"rel":"icon","type":"image/x-icon","href":"https://static.bnto.com/assets/img/favicon.ico"},{"rel":"icon","type":"image/png","href":"https://static.bnto.com/assets/img/favicon-32x32.png","sizes":"32x32"},{"rel":"icon","type":"image/png","href":"https://static.bnto.com/assets/img/favicon-48x48.png","sizes":"48x48"},{"rel":"apple-touch-icon","href":"https://static.bnto.com/assets/img/apple-touch-icon-180x180.png","sizes":"180x180"}],"style":[],"script":[{"src":"https://www.dwin1.com/65876.js","type":"text/javascript","defer":true,"async":true},{"src":"https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=XLQyP3","async":true}],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000